var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoystickDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 290,
    viewBox: "0 0 290 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8336 59.5398C102.887 48.6972 121.661 42.5765 141.021 41.8738C160.381 41.171 179.549 45.9144 196.347 55.5645",
    stroke: "#F4F5F8",
    strokeWidth: 4.50111,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.715 99.0949C150.786 94.4228 136.611 94.5376 123.759 99.4185",
    stroke: "#F4F5F8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.596 83.3077C161.838 79.7455 152.463 77.9433 143.008 78.0039C133.553 78.0646 124.203 79.9869 115.491 83.6613",
    stroke: "#F4F5F8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.634 115.067C148.311 112.899 139.563 112.96 131.271 115.244",
    stroke: "#F4F5F8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.962 67.7003C168.696 62.4566 155.447 59.9086 142.111 60.229C128.775 60.5493 115.663 63.7303 103.663 69.5569",
    stroke: "#F4F5F8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoystickDirection);
export default __webpack_public_path__ + "static/media/joystickDirection.b2254bf3a11c8cf8a0e80dacc5819bba.svg";
export { ForwardRef as ReactComponent };